import {
	ChevronDownIcon,
	Cross2Icon,
	ExclamationTriangleIcon,
	InfoCircledIcon,
} from "@radix-ui/react-icons"

import styles from "./ErrorNotification.module.scss"

import type { NotificationItem } from "./types"

export function StackedBanners({
	notifications,
	onDismiss,
	onClearAll,
	onStackedClick,
}: {
	notifications: NotificationItem[]
	onDismiss: (id: string) => void
	onClearAll: () => void
	onStackedClick: () => void
}) {
	const latestNotification = notifications[notifications.length - 1]
	const isLatestInfo = latestNotification.kind === "info"
	const countLabel = notifications.every((n) => n.kind === "info")
		? "件のお知らせ"
		: notifications.every((n) => n.kind === "error")
			? "件のエラー"
			: "件の通知"

	return (
		<div className={styles.container}>
			<div className={styles.stackedContainer} onClick={onStackedClick}>
				{notifications.length >= 3 && (
					<div className={`${styles.stackCard} ${styles.stackCard2}`} />
				)}
				{notifications.length >= 2 && (
					<div className={`${styles.stackCard} ${styles.stackCard1}`} />
				)}
				<div
					className={`${styles.singleBanner} ${isLatestInfo ? styles.singleBannerInfo : ""}`}
					role={isLatestInfo ? "status" : "alert"}
					aria-live={isLatestInfo ? "polite" : "assertive"}
					aria-atomic="true"
				>
					<div
						className={`${styles.icon} ${isLatestInfo ? styles.iconInfo : ""}`}
					>
						{isLatestInfo ? (
							<InfoCircledIcon width={18} height={18} />
						) : (
							<ExclamationTriangleIcon width={18} height={18} />
						)}
					</div>
					<div className={styles.message}>{latestNotification.message}</div>
					<button
						className={styles.closeButton}
						onClick={(e) => {
							e.stopPropagation()
							onDismiss(latestNotification.id)
						}}
						aria-label="閉じる"
					>
						<Cross2Icon width={16} height={16} />
					</button>
				</div>
			</div>

			<div className={styles.stackInfo} onClick={onStackedClick}>
				<div className={styles.stackCountButton}>
					<span
						className={`${styles.badge} ${
							notifications.every((n) => n.kind === "info")
								? styles.badgeInfo
								: ""
						}`}
					>
						{notifications.length}
					</span>
					<span>{countLabel}</span>
					<ChevronDownIcon width={14} height={14} />
				</div>
				<button
					className={styles.clearAllButton}
					onClick={(e) => {
						e.stopPropagation()
						onClearAll()
					}}
				>
					すべて消去
				</button>
			</div>
		</div>
	)
}
